/**
 * Pre-Process and hash email - return value of an array of email hashes.
 * @email - the email address to process and hash
 **/
// Pre-Process and hash email
var processEmail = function (email) {
	var emailHashes = {};
	var hashedEmails = [];
	var regexObj = {
		whitespaceReplace: /\s+/g,
		google: {
			dotReplace: /\.(?=.*?@gmail\.com)/,
			aliasReplace: /\+[^)]*@/
		}
	};

	// purge fake email domains
	if (email.length && (email.indexOf("@example.com") > -1 || email.indexOf("@test.com") > -1 || email=='test@gmail.com' || email=='testing@gmail.com' || email=='tester@gmail.com') ) {
		// Set fake email addressed to empty so no processing will be done on them.
		email = "";
	}

	if (email.length) {
		// Remove all whitespace and lowercase email address
		email = email.replace(regexObj.whitespaceReplace, '');
		email = email.toLowerCase();

		var valid = new RegExp (/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/).test(email) ? true : false;

		if (valid) {
			// Extra processing needed for google emails
			if (email.indexOf("@gmail.com") > -1) {
				// remove dots within name
				email = email.replace(regexObj.google.dotReplace,'');
				// remove + aliases
				email = email.replace(regexObj.google.aliasReplace,'@');
			}
			// new MD5 instance
			var MD5 = new Hashes.MD5();
			// new SHA1 instance
			var SHA1 = new Hashes.SHA1();
			// new SHA256 instance
			var SHA256 =  new Hashes.SHA256();
			// Hash Email Here
			emailHashes['md5'] = MD5.hex(email);
			emailHashes['sha1'] = SHA1.hex(email);
			emailHashes['sha256'] = SHA256.hex(email);
			hashedEmails = [emailHashes['md5'], emailHashes['sha1'], emailHashes['sha256']];
		}

	}
	return hashedEmails;
};

window.startAts = function(email) {
	if(email){
		// Freestar Identity
		// ensure freestar is loaded
		let freestarPromise = function() {
			const waitLimit = 30000;
			const startTime = Date.now();
			return new Promise(function (resolve, reject) {
				(function freestarCheck(){
					if (typeof window.freestar !== "undefined") {
						return resolve();
					} else if (waitLimit && (Date.now() - startTime) >= waitLimit){
						return reject(new Error("timeout waiting for freestar framework"));
					} else {
						setTimeout(freestarCheck, 30);
					}
				})();
			});
		}

			freestarPromise().then(function(){
				if(freestar){
					let runFreestarIdentity = function(){
						freestar.queue.push(function(){
							let hashResult = processEmail(email);
							if(hashResult && hashResult.length == 3){
								freestar.identity.setIdentity({hashes: {
									sha1: hashResult[1],
									sha256: hashResult[2],
									md5: hashResult[0]
								}});
							}
						});
					};
					// check to see if allowed per GPP/TCF
					utility.isTcfAllowed().then(function(tcfResult){
						if(tcfResult.gdprApplies && tcfResult.gdprAllowed){
							runFreestarIdentity();
						} else {
							utility.isGppAllowed().then(function(gppResult){
								if(gppResult.mspsAllowed){
									runFreestarIdentity();
								}
							});
						}
					});
				}
			}).catch(function(err){
				//console.log(err);
			});

		// LiveRamp ATS
		// Only run LiveRamp ATS code if the LiveRamp ATS feature is active
		if (window.globalcfg.lr) {
			// check to see if Liveramp is an allowed vendor
			utility.isVendorAllowed('liveramp').then(function(vendorResult){
				if(vendorResult.allowed){
					var hashes = processEmail(email);
					var executeLiveRamp = function (ccpaConsentString){
						var atsScript = document.createElement('script');
						atsScript.src = 'https://ats.rlcdn.com/ats.js';
						var payload = {
							"placementID": 13401,
							"rootDomain": "signupgenius.com",
							"ccpaConsentString": ccpaConsentString,
							"emailHashes": hashes,
						};
						if (window.globalcfg.isTest) {
							payload.logging = "debug";
						}
						atsScript.onload = function() {
							window.ats.start(payload);
						};
						document.body.appendChild(atsScript);
					}

					// See if there is a CCPA/USPAPI string to pass in
					// this string will be contextual/relevant even if other frameworks apply, representing that
					// since we already waited on isVendorAllowed check, __uspapi will be present
					__uspapi('getUSPData', 1 , function(uspData, success) {
						if(uspData && uspData.hasOwnProperty('uspString') && uspData.uspString){
							executeLiveRamp(uspData.uspString);
						} else {
							executeLiveRamp('');
						}
					});
				}
			});
		}
	}
};




